<!-- 行业应用 -->
<template>
  <div class="Application">
    <gat-head
      class="Application-head"
      @active-create="activeCreatePopup"
    ></gat-head>
    <div class="training-area">
      <div class="training-area-function">
        <div class="training-left">行业应用</div>
        <!-- <el-button class="add" type="primary" @click="activeCreatePopup">
          <span class="icon"></span>
          创建行业直播
        </el-button> -->
        <search-box :placeholderName="'请输入行业应用视频名称'" :buttonShow="true" @onSearchKey="onSearchKey"></search-box>
        <!-- <el-button class="add" type="primary" @click="GetPageListByName(1)">
          搜索
        </el-button>
        <el-input
          class="ipt"
          v-model.trim="searchKey"
          placeholder="请输入行业应用视频名称"
          prefix-icon="el-icon-search"
          @keyup.native.enter="GetPageListByName(1)"
        ></el-input> -->
      </div>
      <div
        class="content-list"
        v-for="(item, index) in Project.records"
        :key="index"
        @click="onLive(item.videoId)"
      >
        <div class="content-list-img">
          <img :src="item.imgUrl" alt />
        </div>
        <div class="content-list-card">
          <div class="card-title">{{ item.videoName }}</div>
          <div class="card-content">
            {{ item.videoDescribe }}
          </div>
          <div class="card-number">
            <!-- <span class="card-number-one">
              <span class="icon"></span>
              直播中
            </span> -->
            <span class="card-number-two">
              <span class="icon"></span>
              {{ item.clickNum }}人
            </span>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="slot, prev, pager, next"
          :total="totalCount"
        ></el-pagination>
      </div>
      <div class="popup-list">
        <gat-popup
          :class="['popup-update', popupActive === 'update' ? 'on' : 'off']"
          :title="'创建行业直播'"
          :primary-button="'确定'"
          @cancel="cancelPopup"
          @confirm="updateModel"
        >
          <template v-slot:content>
            <div class="intxt">
              <span class="label"><i class="required">*</i>标题：</span>
              <el-input
                placeholder="项目名称最多输入20字"
                v-model.trim="establishForm.title"
                maxlength="20"
              />
            </div>
            <div class="intxt">
              <span class="label"><i class="required">*</i>封面：</span>
              <!-- <el-upload
                class="upload-demo"
                action="https://jsonplaceholder.typicode.com/posts/"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload> -->
            </div>
            <div class="intxt">
              <span class="label"><i class="required">*</i>视频地址：</span>
              <el-input
                placeholder="请输入视频地址"
                v-model.trim="establishForm.videoUrl"
              />
            </div>
            <div class="intxt">
              <span class="label"><i class="required">*</i>简介：</span>
              <el-input
                v-model.trim="establishForm.dialogFormVisible"
                type="textarea"
                :rows="6"
                maxlength="200"
                show-word-limit
                placeholder="简介描述，最多200字"
              />
            </div>
          </template>
        </gat-popup>
      </div>
    </div>
  </div>
</template>

<script>
import APPLICATION from "@/axios/Application/Application.js";
import GatPopup from "@/components/common/GatPopup";
import SearchBox from '@/components/common/SearchBox.vue'

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "ApplicationIndex",
  components: { GatPopup, SearchBox },
  data() {
    return {
      searchKey: "",
      currentPage: 1,
      page: {
        TotalCount: 0,
        pageSize: 10,
        pageNum: 1
      },
      Project: {},
      establishForm: {
        title: "",
        cover: "",
        videoUrl: "",
        briefIntroduction: ""
      },
      popupActive: ""
    };
  },
  //监听属性 类似于data概念
  computed: {
    token() {
      return this.$store.state.token;
    },
    totalCount() {
      return this.page.TotalCount ? this.page.TotalCount : 0;
    }
  },
  //监控data中的数据变化
  watch: {
    token() {
      this.GetPageList();
    },
    page(page) {
      this.currentPage = page.pageNum;
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   // 获取路由来源
  //   next(vm => {
  //     if (to.query.operate === "create" && from.name) vm.activeCreatePopup();
  //   });
  // },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (this.token) {
      this.GetPageList();
    }
  },
  methods: {
    // 新建直播弹窗
    activeCreatePopup() {
      this.popupActive = "update";
    },
    // 去到直播页面
    onLive(val) {
      this.$router.push({
        name: "application-live",
        query: { videoId: val }
      });
    },
    // 分页
    handleCurrentChange(pageIdx) {
      this.GetPageListByName(pageIdx);
    },
    // 获取项目分页
    GetPageList(activePageIndex) {
      // var pageIndex = activePageIndex
      //     ? activePageIndex
      //     : this.Project.pageIndex
      //     ? this.Project.pageIndex + 1
      //     : 1,
      //   pageSize = this.Project.PageSize ? this.Project.PageSize : 10,
      //   data = {
      //     pageNum: pageIndex,
      //     pageSize: pageSize,
      //     videoName: this.searchKey
      //   };
      // APPLICATION.getTradeVideoList(this.token, data).then(result => {
      //   if (result.isSuccess) {
      //     this.Project = result.Data;
      //   }
      // });
      this.GetPageListByName(activePageIndex);
    },
    // 搜索
    onSearchKey(key) {
      this.searchKey = key
      this.GetPageListByName(1)
    },
    GetPageListByName(activePageIndex) {
      let data = {
        // type: "1",
        videoName: this.searchKey,
        pageNum: activePageIndex || 1,
        pageSize: 10
      };
      APPLICATION.getTradeVideoList(data).then(result => {
        console.log('搜索返回', result)
        if (result.isSuccess) {
          this.Project = result.data;
          this.page.TotalCount = result.data.total
        }
      });
    },
    // 创建直播
    updateModel() {
      let establishForm = this.establishForm;
      if (
        establishForm.title &&
        establishForm.cover &&
        establishForm.videoUrl &&
        establishForm.briefIntroduction
      ) {
        console.log("创建直播");
      } else {
        this.$message.error("请将相关内容填写完整");
      }
    },
    // 取消弹窗
    cancelPopup() {
      this.popupActive = "";
      this.establishForm = {
        title: "",
        cover: "",
        videoUrl: "",
        briefIntroduction: ""
      };
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.Application {
  min-height: 100%;
  // height: 100%;
  background-color: #f2f5fc;
  background-size: cover;
  background-position: center;
  color: $font_color_1st;
  padding-top: 80px;
  .training-area {
    width: 1200px;
    padding-bottom: 50px;
    margin: 0 auto;
    .training-area-left {
      // float: left;
      color: #000;
    }
    .training-area-function {
      position: relative;
      // height: 80px;
      margin: 30px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .training-left {
        // float: left;
        height: 18px;
        font-size: 18px;
        line-height: 20px;
        font-weight: bold;
        color: #343434;
        // margin-top: 41px;
        padding-left: 11px;
        border-left: 4px solid #4c88ff;
      }
      .ipt {
        position: relative;
        float: right;
        width: 420px;
        height: 40px;
        background: #ffffff;
        // border: 1px solid #dadfea;
        border-radius: 3px;
        margin-top: 30px;
        font-size: 16px;
        color: #7a7c84;
        box-sizing: border-box;
        z-index: 2;
        &::-ms-clear {
          display: none;
        }
      }
      .search {
        position: absolute;
        right: 115px;
        top: 70px;
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url("../../../public/images/ico17.png") no-repeat;
        z-index: 3;
        cursor: pointer;
      }
      .add {
        float: right;
        display: inline-block;
        margin-top: 30px;
        margin-left: 5px;
        // width: 140px;
        height: 40px;
        border-radius: 3px;
        background-color: $bgc_btn_primary;
        // background: url("../../../public/images/ico14.png") no-repeat;
        cursor: pointer;
        z-index: 2;
        position: relative;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        .icon {
          width: 15px;
          height: 15px;
          display: inline-block;
          background: url("../../assets/images/icon_liveBroadcast.png")
            no-repeat;
          margin-right: 7px;
          vertical-align: bottom;
        }
      }
    }
    .training-area-items {
      margin-top: 0;
      .item {
        display: flex;
        align-items: center;
        width: 100%;
        height: 90px;
        margin-bottom: 20px;
        padding: 0 20px;
        border: 1px solid #dfe4f1;
        box-sizing: border-box;
        background: #fff;
        cursor: pointer;
        transition: all 0.2s ease;
        .icon {
          display: inline-block;
          width: 50px;
          height: 50px;
        }
        .info {
          display: flex;
          flex-direction: column;
          max-width: 75%;
          margin-left: 20px;
          margin-right: auto;
        }
        .name {
          // margin-left: 20px;
          font-size: 18px;
          color: #333;
        }
        .date {
          // margin-left: auto;
          margin-top: 10px;
          font-size: 14px;
          color: #999;
        }
        .edit {
          position: relative;
          top: 1px;
          display: inline-block;
          width: 21px;
          height: 23px;
          margin-left: 40px;
          margin-right: 14px;
          cursor: pointer;
          background: url("../../../public/images/ico15.png") no-repeat;
          z-index: 1;
        }
        .line {
          position: relative;
          top: 2px;
          display: inline-block;
          width: 1px;
          height: 24px;
          margin-right: 12px;
          background: #c0c6cc;
        }
        .delete {
          position: relative;
          float: right;
          display: inline-block;
          width: 24px;
          height: 25px;
          cursor: pointer;
          background: url("../../../public/images/ico16.png") no-repeat;
          z-index: 1;
        }
        &:hover {
          box-shadow: 0 2px 10px 0 #e3e4e6;
          transform: translateY(-4px);
        }
      }
    }
  }
  .content-list {
    height: 200px;
    background: #ffffff;
    border: 1px solid #fff;
    box-shadow: 1px 2px 8px 0px rgba(15, 16, 17, 0.05);
    padding: 31px 30px 0;
    margin-top: 20px;
    display: flex;
    transition: all 0.2s ease;
    cursor: pointer;
    .content-list-img {
      width: 224px;
      height: 140px;
      margin-right: 21px;
      img {
        width: 224px;
        height: 140px;
        background-color: #4c88ff;
      }
    }
    .content-list-card {
      color: #343434;
      line-height: 1;
      flex: 1;
      .card-title {
        height: 17px;
        font-size: 18px;
        font-weight: 400;
        font-family: Microsoft YaHei;
        color: #343434;
        margin-bottom: 20px;
      }
      .card-content {
        height: 65px;
        font-size: 16px;
        font-weight: 400;
        font-family: Microsoft YaHei;
        color: #666666;
        line-height: 22px;
        margin-bottom: 16px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .card-number {
        height: 12px;
        font-size: 14px;
        font-weight: 400;
        color: #4c88ff;
        line-height: 24px;
        .card-number-one {
          margin-right: 37px;
          .icon {
            width: 14px;
            height: 12px;
            display: inline-block;
            background: url("../../assets/images/icon_Live.png") no-repeat;
            margin-right: 11px;
          }
        }
        .card-number-two {
          height: 12px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          .icon {
            width: 18px;
            height: 12px;
            display: inline-block;
            background: url("../../assets/images/icon_watch.png") no-repeat;
            margin-right: 5px;
          }
        }
      }
    }
    &:hover {
      border: 1px solid #4c88ff;
      box-shadow: 0 2px 10px 0 #e3e4e6;
      transform: translateY(-4px);
    }
  }

  // 弹窗
  .popup-list {
    position: relative;
    z-index: 9;
    .popup-update,
    .popup-delete,
    .popup-rename,
    .popup-upload-tip,
    .popup-add-tag,
    .popup-example,
    .popup-report,
    .verify-report {
      &.off {
        display: none;
      }
    }

    .popup-update {
      &::v-deep .popup-inner {
        width: 480px;
        height: 540px;
        overflow: hidden;
      }
      .intxt {
        display: flex;
        margin-top: 10px;
        font-size: 14px;
        &:first-child {
          margin-top: 20px;
        }
        .label {
          min-width: 6em;
          line-height: 40px;
        }
        .el-input {
          margin-top: 0;
        }
      }
    }

    .popup-delete {
      &::v-deep .popup-head {
        border-bottom: 0 none;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -25px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          padding: 15px 0;
          text-align: center;
        }
      }
    }

    .popup-delete-2 {
      &::v-deep .popup-inner {
        width: 360px;
        height: 170px;
      }
      .popup-del-cnt {
        margin-top: -10px;
        .head {
          text-align: center;
        }
      }
    }

    .popup-upload-tip {
      font-size: $font_size;
      &::v-deep .popup-inner {
        width: 840px;
        height: 480px;
      }
      .tips {
        padding-top: 30px;
        color: $font_333_color;
        .tip-list {
          line-height: 2em;
          b {
            color: $active_color;
            font-weight: normal;
          }
        }
      }
      .contact {
        display: block;
        margin: 20px 0;
        color: #999;
      }
      .check-box {
        color: $font_333_color;
        &::v-deep .el-checkbox__input {
          .el-checkbox__inner {
            border-color: #c5cbdc;
          }
          &.is-checked {
            .el-checkbox__inner {
              border-color: #4c88ff;
              background-color: #4c88ff;
            }
          }
        }

        &::v-deep .el-checkbox__label {
          color: $font_333_color;
        }

        &:hover {
          &::v-deep .el-checkbox__input {
            .el-checkbox__inner {
              border-color: #4c88ff;
            }
          }
        }
      }
      .primary {
        width: auto;
      }
    }

    .popup-example {
      &::v-deep .popup-inner {
        width: 900px;
        height: 420px;
      }
      .example-box {
        columns: 2;
        column-gap: 75px;
        -moz-column-rule: 1px solid #d8e5fd;
        -webkit-column-rule: 1px solid #d8e5fd;
        column-rule: 1px solid #d8e5fd;
        padding: 40px 20px 0;
        font-size: $font_size;
        .label-column {
          padding-bottom: 15px;
        }
        .txt {
          height: 100px;
          line-height: 30px;
        }
        b {
          color: $active_color;
          font-weight: normal;
        }
      }
    }

    .popup-report {
      &::v-deep button.cancel {
        display: none;
      }
    }
    .verify-report {
      &::v-deep button.cancel {
        display: none;
      }
    }
  }
}
// .clearfix:after {
//   content: "";
//   display: block;
//   height: 0;
//   clear: both;
//   visibility: hidden;
// }
// .clearfix {
//   *zoom: 1;
// }
</style>
